"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});let t={};const r={resetState(e){t=e||{}},setState(e){t=Object.assign(t,e)},getState(){return t}};exports.Store=r;
